import React from 'react';

import { type SsoConnection } from '@column/api';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@column/ui';

import { StatusBadge } from '~/components/Table';

import { SSO_MODES } from './constants';

export const ModeBadge: React.FC<{ mode: SsoConnection['mode'] }> = ({ mode }) => {
  const option = SSO_MODES.find(({ value }) => value === mode) ?? SSO_MODES[0];
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex cursor-default">
            <StatusBadge tone={option.tone}>{option.label}</StatusBadge>
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{option.description}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
